import { useAuth } from '@swyft/auth';
import { MainNavMenu as MainNavMenuSwyft } from '@swyft/ui';
import { parseJwt } from '@utils/parseJwt';
import React, { ReactElement } from 'react';

export const MainNavMenu = (): ReactElement => {
  const { signOut, user, isAuthenticated } = useAuth();

  const userName = React.useMemo(() => {
    if (user) {
      const payload = parseJwt(user.access_token);
      return payload.name;
    }
    return '';
  }, [user]);

  return (
    <MainNavMenuSwyft
      logoSrc={'/assets/logo_pipelyne.svg'}
      isAuthenticated={isAuthenticated}
      userName={userName}
      signOut={() => signOut()}
    >
      <div className='flex-grow' />
    </MainNavMenuSwyft>
  );
};
